import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=d2a58ab8"
import script from "./Quota.vue?vue&type=script&lang=js"
export * from "./Quota.vue?vue&type=script&lang=js"
import style0 from "./Quota.vue?vue&type=style&index=0&id=d2a58ab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports